import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(
  theme => ({
    buttonContainer: {
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(2),
      marginTop: theme.spacing(2)
    },
    card: {
      borderRadius: 16,
      boxShadow: theme.shadows[3],
      marginBottom: theme.spacing(2),
      padding: theme.spacing(2),
      textAlign: "center",
      width: 460
    },
    centerContainer: {
      alignItems: "center",
      backgroundColor: theme.palette.background.default,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      minHeight: "100vh",
      padding: theme.spacing(1)
    },
    getStartedButton: {
      "&:hover": {
        backgroundColor: "#1039C9"
      },
      backgroundColor: "#1848FE",
      color: "#fff",
      marginBottom: theme.spacing(1.5),
      padding: theme.spacing(1.5),
      width: "100%"
    },
    infoCard: {
      alignItems: "center", // Align items in the center vertically
      backgroundColor: "#F4F8FF",
      borderRadius: theme.shape.borderRadius,
      color: "#002972",
      display: "flex",
      fontSize: 12,
      marginTop: theme.spacing(2),
      padding: theme.spacing(1.0),
      width: "100%"
    },
    infoIcon: {
      marginRight: theme.spacing(1),
      stroke: "#002972",
      strokeWidth: 1.5
    },
    infoLogo: {
      height: 17,
      marginBottom: theme.spacing(3),
      marginRight: theme.spacing(1),
      marginTop: theme.spacing(1)
    },
    logo: {
      height: 70,
      marginBottom: theme.spacing(3),
      marginTop: theme.spacing(3)
    },
    setupLaterButton: {
      "& .MuiButton-label": {
        fontWeight: 166
      },
      borderColor: "#1848FE",
      color: "#1848FE",
      padding: theme.spacing(1.5),
      width: "100%"
    },
    subtitle: {
      fontSize: 16,
      fontWeight: 400,
      marginBottom: theme.spacing(2),
      textAlign: "center"
    },
    title: {
      color: "#0030FF",
      fontSize: 26,
      fontWeight: 700,
      marginBottom: theme.spacing(2),
      textAlign: "center"
    }
  }),
  { name: "MfaGetStartedPage" }
);
